import styled from "styled-components";

export const FormStepCount = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  display: ${(props) => props.isIe && "table"};
  left: ${(props) => props.isIe && "0px"};
  right: ${(props) => props.isIe && "0px"};
  text-align: ${(props) => props.isIe && "center"};
`;

export const StepCountText = styled.div`
  font-weight: 100;
  font-size: 0.9em;
  letter-spacing: 0.8px;
`;

export const StepCountGraphics = styled.div`
  display: flex;
  width: 145px;
  margin: 8px 0;
  margin: ${(props) => props.isIe && "8px auto"};
  justify-content: space-between;
`;

export const Bar = styled.div`
  height: 6px;
  width: 45px;
  border-radius: 4px;
  background-color: ${(props) => (props.completed ? "#fff" : "#a56ec9")};
`;

export const Field = styled.div`
  position: relative;
`;

export const Input = styled.input`
  color: #000;
  background-color: #fff;
  border: 1px solid #a3bac6;
  width: 275px;
  border-radius: 3px;
  margin: 0.4rem 0 16px 0;
  padding: 0.5rem 0.625rem 0.5625rem;
  font-size: 0.9375rem;
  height: 2.6875rem;

  ::placeholder {
    color: #333;
    opacity: 0.5;
    font-weight: 300;
  }

  &:focus {
    border: 2px solid #f2008c;
    outline: none;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  width: 275px;
  margin: 7px 0 16px 0;
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 3px;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
  border-radius: 3px;
  transition: 0.1s ease-in-out;
`;

export const Checkbox = styled.input``;

export const Label = styled.label`
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  top: 5px;
  padding-left: 25px;
  font-weight: 100;
  font-size: 0.78em;

  ${Checkbox} {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  ${Checkmark} {
    position: absolute;
    top: 3px;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  ${Checkbox}:checked ~ ${Checkmark} {
    background-color: #f2008c;

    &:after {
      content: "";
      width: 5px;
      height: 5px;
      background-color: #fff;
      position: absolute;
      top: 5px;
      left: 5px;
      border-radius: 50%;
    }
  }

  a {
    color: white;
  }
`;

export const Error = styled.div`
  padding-top: 0;
  padding-right: 0;
  color: #f2008c;
  position: absolute;
  top: ${(props) => (props.checkbox ? "43px" : "50px")};
  font-size: 0.8em;
  font-weight: 600;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Button = styled.button`
  background: #f2008c;
  color: #fff;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Raleway;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #f2008c;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;
  margin: 20px 0 30px 0;

  &:hover {
    background: #b70d6c;
    border: 1px solid #b70d6c;
  }
`;

export const Previous = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a56ec9;
  font-size: 0.9em;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #fff;
  }

  svg {
    margin-right: 10px;
  }
`;

export const Text = styled.div`
  font-size: 1.4em;
  text-align: center;
  width: 310px;
  font-weight: 100;
`;
